import { render } from "./SingleEvent.vue?vue&type=template&id=78dff953&scoped=true"
import script from "./SingleEvent.vue?vue&type=script&lang=js"
export * from "./SingleEvent.vue?vue&type=script&lang=js"

import "./SingleEvent.vue?vue&type=style&index=0&id=78dff953&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dff953"]])

export default __exports__